import { useSession } from '@tgtg/core/session';
import { Navigate, Outlet } from 'react-router';
import { COMPLETE_ACCOUNT_PATH } from 'src/core/paths/paths';

const RequirePasswordSet = () => {
  const { session } = useSession();
  // Admins reach myCharity via SSO and have no charity password to set.
  if (!session.admin && !session.hasPassword) {
    return <Navigate to={COMPLETE_ACCOUNT_PATH} replace />;
  }
  return <Outlet />;
};

export default RequirePasswordSet;
